// Generated by scripts/generateStateTaxRates.js from the Tax Foundation's
// "State Individual Income Tax Rates and Brackets, 2026". Do not edit by hand:
// regenerate from the workbook. State-specific rules for retirees that the
// workbook does not carry live in stateRetirementRules.js.
//
// For each state: brackets as [rate, income over] for a single filer and a
// married couple filing jointly; the standard deduction and personal exemption
// as [single, couple]. A deduction or exemption marked as a credit comes off
// the tax, not the income. Local income taxes are not included.

export const STATE_TAX_YEAR = '2026';

export const STATE_TAX_RATES = {
  AK: { name: 'Alaska', none: true },
  AL: {
    name: 'Alabama',
    single: [[0.02, 0], [0.04, 500], [0.05, 3000]],
    married: [[0.02, 0], [0.04, 1000], [0.05, 6000]],
    deduction: [3000, 8500], exemption: [1500, 3000],
  },
  AR: {
    name: 'Arkansas',
    single: [[0.02, 0], [0.039, 4600]],
    married: [[0.02, 0], [0.039, 4600]],
    deduction: [2470, 4940], exemption: [29, 58], exemptionIsCredit: true,
  },
  AZ: {
    name: 'Arizona',
    single: [[0.025, 0]],
    married: [[0.025, 0]],
    deduction: [8350, 16700], exemption: [0, 0],
  },
  CA: {
    name: 'California',
    single: [[0.01, 0], [0.02, 11079], [0.04, 26264], [0.06, 41452], [0.08, 57542], [0.093, 72724], [0.103, 371479], [0.113, 445771], [0.123, 742953], [0.133, 1000000]],
    married: [[0.01, 0], [0.02, 22158], [0.04, 52528], [0.06, 82904], [0.08, 115084], [0.093, 145448], [0.103, 742958], [0.113, 891542], [0.123, 1000000], [0.133, 1485906]],
    deduction: [5540, 11080], exemption: [153, 306], exemptionIsCredit: true,
  },
  CO: {
    name: 'Colorado',
    single: [[0.044, 0]],
    married: [[0.044, 0]],
    deduction: [16100, 32200], exemption: [0, 0],
  },
  CT: {
    name: 'Connecticut',
    single: [[0.02, 0], [0.045, 10000], [0.055, 50000], [0.06, 100000], [0.065, 200000], [0.069, 250000], [0.0699, 500000]],
    married: [[0.02, 0], [0.045, 20000], [0.055, 100000], [0.06, 200000], [0.065, 400000], [0.069, 500000], [0.0699, 1000000]],
    deduction: [0, 0], exemption: [15000, 24000],
  },
  DC: {
    name: 'District of Columbia',
    single: [[0.04, 0], [0.06, 10000], [0.065, 40000], [0.085, 60000], [0.0925, 250000], [0.0975, 500000], [0.1075, 1000000]],
    married: [[0.04, 0], [0.06, 10000], [0.065, 40000], [0.085, 60000], [0.0925, 250000], [0.0975, 500000], [0.1075, 1000000]],
    deduction: [16100, 32200], exemption: [0, 0],
  },
  DE: {
    name: 'Delaware',
    single: [[0.022, 2000], [0.039, 5000], [0.048, 10000], [0.052, 20000], [0.0555, 25000], [0.066, 60000]],
    married: [[0.022, 2000], [0.039, 5000], [0.048, 10000], [0.052, 20000], [0.0555, 25000], [0.066, 60000]],
    deduction: [3250, 6500], exemption: [110, 220], exemptionIsCredit: true,
  },
  FL: { name: 'Florida', none: true },
  GA: {
    name: 'Georgia',
    single: [[0.0519, 0]],
    married: [[0.0519, 0]],
    deduction: [12000, 24000], exemption: [0, 0],
  },
  HI: {
    name: 'Hawaii',
    single: [[0.014, 0], [0.032, 9600], [0.055, 14400], [0.064, 19200], [0.068, 24000], [0.072, 36000], [0.076, 48000], [0.079, 125000], [0.0825, 175000], [0.09, 225000], [0.1, 275000], [0.11, 325000]],
    married: [[0.014, 0], [0.032, 19200], [0.055, 28800], [0.064, 38400], [0.068, 48000], [0.072, 72000], [0.076, 96000], [0.079, 250000], [0.0825, 350000], [0.09, 450000], [0.1, 550000], [0.11, 650000]],
    deduction: [4400, 8800], exemption: [1144, 2288],
  },
  IA: {
    name: 'Iowa',
    single: [[0.038, 0]],
    married: [[0.038, 0]],
    deduction: [16100, 32200], exemption: [40, 80], exemptionIsCredit: true,
  },
  ID: {
    name: 'Idaho',
    single: [[0.053, 4811]],
    married: [[0.053, 9622]],
    deduction: [16100, 32200], exemption: [0, 0],
  },
  IL: {
    name: 'Illinois',
    single: [[0.0495, 0]],
    married: [[0.0495, 0]],
    deduction: [0, 0], exemption: [2925, 5850],
  },
  IN: {
    name: 'Indiana',
    single: [[0.0295, 0]],
    married: [[0.0295, 0]],
    deduction: [0, 0], exemption: [1000, 2000],
  },
  KS: {
    name: 'Kansas',
    single: [[0.052, 0], [0.0558, 23000]],
    married: [[0.052, 0], [0.0558, 46000]],
    deduction: [3605, 8240], exemption: [9160, 18320],
  },
  KY: {
    name: 'Kentucky',
    single: [[0.035, 0]],
    married: [[0.035, 0]],
    deduction: [3360, 3360], exemption: [0, 0],
  },
  LA: {
    name: 'Louisiana',
    single: [[0.03, 0]],
    married: [[0.03, 0]],
    deduction: [12875, 25750], exemption: [0, 0],
  },
  MA: {
    name: 'Massachusetts',
    single: [[0.05, 0], [0.09, 1083150]],
    married: [[0.05, 0], [0.09, 1083150]],
    deduction: [0, 0], exemption: [4400, 8800],
  },
  MD: {
    name: 'Maryland',
    single: [[0.02, 0], [0.03, 1000], [0.04, 2000], [0.0475, 3000], [0.05, 100000], [0.0525, 125000], [0.055, 150000], [0.0575, 250000], [0.0625, 500000], [0.065, 1000000]],
    married: [[0.02, 0], [0.03, 1000], [0.04, 2000], [0.0475, 3000], [0.05, 150000], [0.0525, 175000], [0.055, 225000], [0.0575, 300000], [0.0625, 600000], [0.065, 1200000]],
    deduction: [3350, 6700], exemption: [3200, 6400],
  },
  ME: {
    name: 'Maine',
    single: [[0.058, 0], [0.0675, 27399], [0.0715, 64849]],
    married: [[0.058, 0], [0.0675, 54849], [0.0715, 129749]],
    deduction: [8350, 16700], exemption: [5300, 10600],
  },
  MI: {
    name: 'Michigan',
    single: [[0.0425, 0]],
    married: [[0.0425, 0]],
    deduction: [0, 0], exemption: [5900, 11800],
  },
  MN: {
    name: 'Minnesota',
    single: [[0.0535, 0], [0.068, 33310], [0.0785, 109430], [0.0985, 203150]],
    married: [[0.0535, 0], [0.068, 48700], [0.0785, 193480], [0.0985, 337930]],
    deduction: [15300, 30600], exemption: [0, 0],
  },
  MO: {
    name: 'Missouri',
    single: [[0.02, 1348], [0.025, 2696], [0.03, 4044], [0.035, 5392], [0.04, 6740], [0.045, 8088], [0.047, 9436]],
    married: [[0.02, 1348], [0.025, 2696], [0.03, 4044], [0.035, 5392], [0.04, 6740], [0.045, 8088], [0.047, 9436]],
    deduction: [16100, 32200], exemption: [0, 0],
  },
  MS: {
    name: 'Mississippi',
    single: [[0.04, 10000]],
    married: [[0.04, 10000]],
    deduction: [2300, 4600], exemption: [6000, 12000],
  },
  MT: {
    name: 'Montana',
    single: [[0.047, 0], [0.0565, 47500]],
    married: [[0.047, 0], [0.0565, 95000]],
    deduction: [16100, 32200], exemption: [0, 0],
  },
  NC: {
    name: 'North Carolina',
    single: [[0.0399, 0]],
    married: [[0.0399, 0]],
    deduction: [12750, 25500], exemption: [0, 0],
  },
  ND: {
    name: 'North Dakota',
    single: [[0.0195, 48475], [0.025, 244825]],
    married: [[0.0195, 80975], [0.025, 298075]],
    deduction: [16100, 32200], exemption: [0, 0],
  },
  NE: {
    name: 'Nebraska',
    single: [[0.0246, 0], [0.0351, 4130], [0.0455, 24760]],
    married: [[0.0246, 0], [0.0351, 8250], [0.0455, 49530]],
    deduction: [8850, 17700], exemption: [176, 352], exemptionIsCredit: true,
  },
  NH: { name: 'New Hampshire', none: true },
  NJ: {
    name: 'New Jersey',
    single: [[0.014, 0], [0.0175, 20000], [0.035, 35000], [0.05525, 40000], [0.0637, 75000], [0.0897, 500000], [0.1075, 1000000]],
    married: [[0.014, 0], [0.0175, 20000], [0.0245, 50000], [0.035, 70000], [0.05525, 80000], [0.0637, 150000], [0.0897, 500000], [0.1075, 1000000]],
    deduction: [0, 0], exemption: [1000, 2000],
  },
  NM: {
    name: 'New Mexico',
    single: [[0.015, 0], [0.032, 5500], [0.043, 16500], [0.047, 33500], [0.049, 66500], [0.059, 210000]],
    married: [[0.015, 0], [0.032, 8000], [0.043, 25000], [0.047, 50000], [0.049, 100000], [0.059, 315000]],
    deduction: [16100, 32200], exemption: [0, 0],
  },
  NV: { name: 'Nevada', none: true },
  NY: {
    name: 'New York',
    single: [[0.039, 0], [0.044, 8500], [0.0515, 11700], [0.054, 13900], [0.059, 80650], [0.0685, 215400], [0.0965, 1077550], [0.103, 5000000], [0.109, 25000000]],
    married: [[0.039, 0], [0.044, 17150], [0.0515, 23600], [0.054, 27900], [0.059, 161550], [0.0685, 323200], [0.0965, 2155350], [0.103, 5000000], [0.109, 25000000]],
    deduction: [8000, 16050], exemption: [0, 0],
  },
  OH: {
    name: 'Ohio',
    single: [[0.0275, 26050]],
    married: [[0.0275, 26050]],
    deduction: [0, 0], exemption: [2400, 4800],
  },
  OK: {
    name: 'Oklahoma',
    single: [[0.025, 3750], [0.035, 4900], [0.045, 7200]],
    married: [[0.025, 7500], [0.035, 9800], [0.045, 14400]],
    deduction: [6350, 12700], exemption: [1000, 2000],
  },
  OR: {
    name: 'Oregon',
    single: [[0.0475, 0], [0.0675, 4550], [0.0875, 11400], [0.099, 125000]],
    married: [[0.0475, 0], [0.0675, 9100], [0.0875, 22800], [0.099, 250000]],
    deduction: [2910, 5820], exemption: [256, 512], exemptionIsCredit: true,
  },
  PA: {
    name: 'Pennsylvania',
    single: [[0.0307, 0]],
    married: [[0.0307, 0]],
    deduction: [0, 0], exemption: [0, 0],
  },
  RI: {
    name: 'Rhode Island',
    single: [[0.0375, 0], [0.0475, 82050], [0.0599, 186450]],
    married: [[0.0375, 0], [0.0475, 82050], [0.0599, 186450]],
    deduction: [11200, 22400], exemption: [5250, 10500],
  },
  SC: {
    name: 'South Carolina',
    single: [[0, 0], [0.03, 3640], [0.06, 18230]],
    married: [[0, 0], [0.03, 3640], [0.06, 18230]],
    deduction: [8350, 16700], exemption: [0, 0],
  },
  SD: { name: 'South Dakota', none: true },
  TN: { name: 'Tennessee', none: true },
  TX: { name: 'Texas', none: true },
  UT: {
    name: 'Utah',
    single: [[0.045, 0]],
    married: [[0.045, 0]],
    deduction: [966, 1932], exemption: [0, 0], deductionIsCredit: true,
  },
  VA: {
    name: 'Virginia',
    single: [[0.02, 0], [0.03, 3000], [0.05, 5000], [0.0575, 17000]],
    married: [[0.02, 0], [0.03, 3000], [0.05, 5000], [0.0575, 17000]],
    deduction: [8750, 17500], exemption: [930, 1860],
  },
  VT: {
    name: 'Vermont',
    single: [[0.0335, 0], [0.066, 49400], [0.076, 119700], [0.0875, 249700]],
    married: [[0.0335, 0], [0.066, 82500], [0.076, 199450], [0.0875, 304000]],
    deduction: [7650, 15300], exemption: [5300, 10600],
  },
  WA: {
    name: 'Washington',
    single: [[0.07, 0], [0.09, 1000000]],
    married: [[0.07, 0], [0.09, 1000000]],
    deduction: [278000, 278000], exemption: [0, 0], gainsOnly: true,
  },
  WI: {
    name: 'Wisconsin',
    single: [[0.035, 0], [0.044, 15110], [0.053, 51950], [0.0765, 332720]],
    married: [[0.035, 0], [0.044, 20150], [0.053, 69260], [0.0765, 443630]],
    deduction: [13960, 25840], exemption: [700, 1400],
  },
  WV: {
    name: 'West Virginia',
    single: [[0.0222, 0], [0.0296, 10000], [0.0333, 25000], [0.0444, 40000], [0.0482, 60000]],
    married: [[0.0222, 0], [0.0296, 10000], [0.0333, 25000], [0.0444, 40000], [0.0482, 60000]],
    deduction: [0, 0], exemption: [2000, 4000],
  },
  WY: { name: 'Wyoming', none: true },
};
